import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Link from "./link";
import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      logoImg: wpMediaItem(title: { eq: "ARC-logo" }) {
        altText
        localFile {
          publicURL
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP]
              quality: 100
              transformOptions: { cropFocus: CENTER, fit: CONTAIN }
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
          }
        }
      }
    }
  `);
  const logoImg = data.logoImg.localFile.childImageSharp.gatsbyImageData;

  return (
    <footer className=" bg-footer py-5">
      <Container>
        <Row className="text-white justify-content-center">
          <Col
            className="text-center mb-3 mb-lg-0 text-lg-start"
            xs={12}
            md={6}
            lg={{ span: 2, order: 1 }}
          >
            <h3>Address</h3>
            <p>
              Archer House
              <br />
              Britland Estate
              <br />
              Northbourne Rd <br />
              Eastbourne <br />
              BN22 8PW
            </p>
            <h3>Email</h3>
            <Link to="mailto:info@arc-wts.co.uk">info@arc-wts.co.uk</Link>
          </Col>
          <Col
            className="text-center text-lg-start mb-3 mb-lg-0 "
            xs={12}
            md={6}
            lg={{ span: 2, order: 2 }}
          >
            <h3>Opening hours</h3>
            <p>
              <span className="fw-bold">Monday - Friday</span>
              <br />
              9:00 to 17:00
              <br />
              <span className="fw-bold">Saturday & Sunday</span>
              <br />
              Closed
            </p>
            <h3>Telephone</h3>
            <Link to="tel:+442033933973">0203 393 3973</Link>
          </Col>
          <Col xs={{ span: 12, order: "first" }} lg={{ span: 4, order: 3 }}>
            <div
              className="rounded-circle-new bg-white text-center mb-5 mb-lg-0 align-items-center d-flex mx-auto justify-content-center"
              style={{ width: "150px", height: "150px", overflow: "hidden" }}
            >
              <video
                className="video-logo-new rounded-circle-new bg-white"
                loop
                autoPlay
                muted
                src="https://arc-writing.rjmdigital.net/wp-content/uploads/2023/09/arc_-_logo_animation-1080p.mp4"
                playsinline
                type="video/mp4"
              >
                Sorry, your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={{ span: 1, order: 4 }}
            className="text-md-end text-center mt-md-3 mt-lg-0 "
          >
            <ul className=" list-unstyled  text-lg-start text-center ">
              <li className="fs-5 pt-2 ">
                <Link to="/" style={quickLinks}>
                  Home
                </Link>
              </li>
              <li className="fs-5 pt-2 ">
                <Link to="/services" style={quickLinks}>
                  Services
                </Link>
              </li>
              <li className="fs-5 pt-2">
                <Link to="/about" style={quickLinks}>
                  About
                </Link>
              </li>

              <li className="fs-5 pt-2 ">
                <Link to="/contact" style={quickLinks}>
                  Contact
                </Link>
              </li>
              <li className="fs-5 pt-2 ">
                <Link to="/policies/privacy-policy" style={quickLinks}>
                  Policy
                </Link>
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={{ span: 2, order: 4 }}
            className="text-md-end text-center mt-md-3 mt-lg-0 "
          >
            <ul className=" list-unstyled ps-lg-4 ps-xl-0 text-lg-start text-center ">
              <li className="fs-5 pt-2 ">
                <Link to="/services/copywriting-london" style={quickLinks}>
                  Copywriting London
                </Link>
              </li>
              <li className="fs-5 pt-2 ">
                <Link to="/services/aesthetics-copywriter" style={quickLinks}>
                  Aesthetics Copywriter
                </Link>
              </li>
              <li className="fs-5 pt-2">
                <Link
                  to="/services/property-copywriter-london"
                  style={quickLinks}
                >
                  Property Copywriter
                </Link>
              </li>
            </ul>
          </Col>
          <Col
            className="d-md-flex align-items-center justify-content-center d-lg-block"
            xs={12}
            md={6}
            lg={{ span: 1, order: 5 }}
          >
            {" "}
            <ul className="pl-0 list-unstyled d-flex d-lg-block justify-content-center text-lg-end text-center">
              <li className="fs-3 px-3 px-lg-0 d-inline-block d-lg-block ">
                <Link className="social-icon" to="https://www.facebook.com">
                  <FaFacebookSquare style={socialIcons} />
                </Link>
              </li>
              <li className=" mx-3 mx-lg-0 d-inline-block d-lg-block fs-3">
                <Link className="social-icon" to="https://www.instagram.com">
                  <FaInstagram style={socialIcons} />
                </Link>
              </li>
              <li className=" mx-3 mx-lg-0 fs-3 d-inline-block d-lg-block ">
                <Link className="social-icon" to="https://www.linkedin.com">
                  <FaLinkedin style={socialIcons} />
                </Link>
              </li>
              <li className=" mx-3 mx-lg-0 d-inline-block d-lg-block fs-3">
                <Link className="social-icon" to="https://www.youtube.com">
                  <FaTwitter style={socialIcons} />
                </Link>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="text-center mt-3">
          <hr style={{ height: "2px", color: "white" }} />
          <Col>
            <p
              className="text-white"
              href="https://www.rjm.digital/web-design-sussex"
            >
              ARC Writing and Translation Services is a trading name of AMG
              Translations Limited, Registered address: Archer House Britland
              Estate, Northbourne Road, Eastbourne, East Sussex, BN22 8PW,
              Company registration no. 09315878 VAT No.: 267933854 <br /> All
              Rights Reserved |{" "}
              
              <a
                className="d-inline-flex align-items-center"
                href="https://www.mativus.com"
              >
                Website designed & built by
                <StaticImage
                  src="../images/mativus-logo.png"
                  style={{ width: "100px" }}
                  imgStyle={{ objectFit: "contain" }}
                  className="ms-2"
                />
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

const socialIcons = {};

const quickLinks = {};

export default Footer;
